import { $t } from "@/plugins/i18n";
const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/system",
    name: "System",
    redirect: "/system/user",
    component: Layout,
    meta: {
      title: $t("menus.system"),
      showLink: true,
      icon: "ep:setting"
    },
    children: [
      {
        path: "/system/user",
        name: "User",
        component: () => import("@/views/system/user/index.vue"),
        meta: {
          title: $t("menus.systemUser"),
          showLink: false
        }
      },
      {
        path: "/system/menu",
        name: "Menu",
        component: () => import("@/views/system/menu/index.vue"),
        meta: {
          title: $t("menus.systemMenu"),
          showLink: true
        }
      },
      {
        path: "/system/data",
        name: "Data",
        component: () => import("@/views/system/data/index.vue"),
        meta: {
          title: $t("menus.systemDict"),
          showLink: true
        }
      },
      {
        path: "/system/basicinfo",
        name: "Basicinfo",
        component: () => import("@/views/system/basicinfo/index.vue"),
        meta: {
          title: $t("menus.basicinfo"),
          showLink: true
        }
      },
      {
        path: "/system/notifys",
        name: "Notifys",
        component: () => import("@/views/system/notifys/index.vue"),
        meta: {
          title: $t("menus.notifys"),
          showLink: true
        }
      },
      {
        path: "/system/downloadLink",
        name: "downloadLink",
        component: () => import("@/views/system/downloadLink/index.vue"),
        meta: {
          title: $t("menus.downloadLink"),
          showLink: true
        }
      },
      {
        path: "/system/statisticalData",
        name: "statisticalData",
        component: () => import("@/views/system/statisticalData/index.vue"),
        meta: {
          title: $t("menus.statisticalData"),
          showLink: true
        }
      },
      {
        path: "/system/statisticalCode",
        name: "statisticalCode",
        component: () => import("@/views/system/statisticalCode/index.vue"),
        meta: {
          title: $t("menus.statisticalCode"),
          showLink: true
        }
      },
      {
        path: "/system/header",
        name: "header",
        component: () => import("@/views/system/header/index.vue"),
        meta: {
          title: $t("menus.titles"),
          showLink: true
        }
      },
      {
        path: "/system/pwaDownloadCount",
        name: "pwaDownloadCount",
        component: () => import("@/views/system/pwaDownloadCount/index.vue"),
        meta: {
          title: $t("menus.pwaDownloadCount"),
          showLink: true
        }
      },
      {
        path: "/system/gameLink",
        name: "gameLink",
        component: () => import("@/views/system/gameLink/index.vue"),
        meta: {
          title: $t("menus.gameLink"),
          showLink: true
        }
      },
      {
        path: "/system/pushNotice",
        name: "pushNotice",
        component: () => import("@/views/system/pushNotice/index.vue"),
        meta: {
          title: $t("menus.pushNotice"),
          showLink: true
        }
      },
      {
        path: "/system/password",
        name: "Password",
        component: () => import("@/views/system/password/index.vue"),
        meta: {
          title: $t("menus.password"),
          showLink: true
        }
      }
    ]
  }
] satisfies Array<RouteConfigsTable>;
